/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Usha        10/01/2020      2416: Flow to NLP change
CHID-2     Usha        17/02/2020      2560: 400 Bad Request Issue with gemtriageapi-qa3 POST GemTriage/UpdateTriageLogSymptoms
 *********************************************************************************/
import { Component, classnames as cx } from "@mna/react";
import Map from "features/Map/WithLocationSearch";
import LoadingScreen from "features/LoadingScreen";
import { Trans } from "react-i18next";
import i18n from "./../../../i18n";
import { careOptions } from "../../../server/triage/constants";
import { checkAndGetLocalStorageValue } from "../../../features/utils"

export default class LocationScreen extends Component {
  constructor(props) {
    super(props);
    const { state, history, setState } = this.props;
    if (state.isLoading_ConfirmDetails) {
      setState({ isLoading_ConfirmDetails: false });
    }
  }
  static getDerivedStateFromError(err) {
    console.log("getDerivedStateFromError", err);
    return { hasError: true };
  }

  componentDidCatch(err, info) {
    console.log(err, info);
  }

  state = {
    currentLocation: null, // From geolocation or map search
    currentLocationName: "",
    currentLocationParts: {},
    hasError: false,
    isSecondTimeCalled: false,
    searchBoxDisplay: false,
  };


  componentDidMount() {
    const { state, history, setState } = this.props;
    var locationObj = state.triageRequest.location
    setState({
      isLoading: false,
      UserNavigatedToQT: false,
      triageResponse: {
        ...state.triageResponse,
        recommendedCareOptions: [],
      },
    });
    if (state.triageRequest.location.position) {
      //when coming again to this page from side menu this is called
      this.setState({
        currentLocation: locationObj.position,
        currentLocationName: locationObj.name,
        currentLocationParts: locationObj.parts,
        isSecondTimeCalled: true,
      });


    } else {
      this.setState({
        isSecondTimeCalled: false,
      });
    }
    this.props.actions.refreshGeolocation();
  }

  componentWillUnmount() {
    //const { unsubscribeGeolocation } = this.props.actions
    //unsubscribeGeolocation({ watchId: this.watchId })
  }

  onCurrentLocationChange = ({
    currentLocation,
    currentLocationName,
    currentLocationParts,
  }) => {
    if (this.state.isSecondTimeCalled) {
      this.setState({
        isSecondTimeCalled: false,
      });
    } else {
      console.log("onCurrentLocationChange", {
        lat: currentLocation.lat,
        lng: currentLocation.lng,
        currentLocationName,
        currentLocationParts,
      });
      this.setState({
        currentLocation,
        currentLocationName,
        currentLocationParts,
      });
    }
  };

  handleSearchBox = (e) => {
    e.preventDefault();
    this.setState({ searchBoxDisplay: true });
    var searchBox = document.getElementById("google-map-searchbox");
    if (searchBox) searchBox.focus();
  };

  onNext = async () => {
    const { state, setState, actions, history } = this.props;
    const { triageRequest } = state; // App state
    const { currentLocation, currentLocationName, currentLocationParts } =
      this.state; // Page state
    this.setState({
      currentLocation,
      currentLocationName,
      currentLocationParts,
    });
    gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
    window.sessionStorage.setItem("lat", currentLocation.lat);
    window.sessionStorage.setItem("lng", currentLocation.lng);
    window.sessionStorage.setItem(
      "country",
      currentLocationParts.country || ""
    );
    window.sessionStorage.setItem(
      "state",
      currentLocationParts.administrative_area_level_1 || ""
    );
    window.sessionStorage.setItem(
      "currentLocationName",
      currentLocationName || ""
    );
    window.sessionStorage.setItem(
      "city",
      currentLocationParts.locality ||
      currentLocationParts.administrative_area_level_3 ||
      currentLocationParts.administrative_area_level_2 ||
      ""
    );

    if (!state.triageRequest.data || !state.triageRequest.data.email) {
      setState({
        phone: "",
      })
    }
    setState({
      isLoading: true,
    });

    const redirectToSymptomPage = () => {
      //CHID-1
      let hHasValue = state.triageRequest.weight;
      let wHasValue = state.triageRequest.height;
      if (!hHasValue && !wHasValue) {
        sessionStorage.setItem("heightRequired", false);
        sessionStorage.setItem("weightRequired", false);
      }
      const obj = { name: "symptoms", previous: "location" };
      state.triageRequest.activeMenu = triageRequest.emergency || state.isFacility || state.triageRequest.isFacilitySearch
        ? "emergency"
        : state.isTravelAid2 && !state.triageRequest.isFacilitySearch ? "start" : obj.name;
      history.push(
        `/find-care-options/${triageRequest.emergency || state.isFacility || state.triageRequest.isFacilitySearch ? "emergency" : state.isTravelAid2 && !state.triageRequest.isFacilitySearch ? "send-information" : obj.name
        }`
      );
      setState({ quickTelemedicine: false });
      setState({ isMenuClick: true });
    }

    actions
      .submitTriageLocation({
        location: {
          name: currentLocationName,
          parts: currentLocationParts,
          position: currentLocation,
          ...(currentLocation || {}),
        },
      })
      .then(async () => {

        // Continue without waiting for API response
        if (triageRequest.emergency || state.isFacility || state.triageRequest.isFacilitySearch) {
          actions.clearTriageSessionResults();
        }
        if (
          !triageRequest.emergency && !state.isFacility &&
          !triageRequest.selectRecentPhysicalInjury &&
          (state.QuickTeleMedAvailableOrNot) && !state.isTravelAid2 && !state.triageRequest.isFacilitySearch
        ) {
          console.log("Inside terms flow: ");
          var lang = i18n.language;
          var careOptionList =
            await actions.getTriageScoreFromAnswers({ lang });

          if (careOptionList && careOptionList.length > 0) {
            var teleMedCareOption = careOptionList.filter((item) => {
              if (item.alt === careOptions.Telemedicine) {
                return item;
              }
            })

            if (teleMedCareOption.length > 0 && (!state.quickTelemedicine || state.quickTelemedicine == undefined)) {
              state.triageRequest.activeMenu = "care-options";
              history.push(
                "/find-care-options/quick-telemedicine-screen"
              );
              setState({ quickTelemedicine: true });
            } else {
              redirectToSymptomPage();
            }
          } else {
            redirectToSymptomPage();
          }
        } else if (state.isTravelAid2 && !state.triageRequest.emergency && !state.triageRequest.isFacilitySearch) {
          console.log("Inside Travel Aid flow: ");
          var lang = i18n.language;
          var careOptionList =
            await actions.getServiceIdList();
          sessionStorage.setItem("locationScreen", true);
          setState({
            LocationScreen: true
          })
          if (careOptionList && careOptionList.length > 0) {
            var teleMedCareOption = careOptionList.filter((item) => {
              if (item.alt === careOptions.Telemedicine) {
                return item;
              }
            })
            if (teleMedCareOption.length > 0) {
              debugger;
              let hHasValue = state.triageRequest.weight;
              let wHasValue = state.triageRequest.height;
              if (!hHasValue && !wHasValue) {
                sessionStorage.setItem("heightRequired", false);
                sessionStorage.setItem("weightRequired", false);
              }

              state.triageRequest.activeMenu = "start";
              history.push(
                "/find-care-options/send-information"
              );
            } else {
              redirectToSymptomPage();
            }
          }
        } else {
          redirectToSymptomPage();
        }
      });
  };

  render() {
    const { state, setState } = this.props;
    const { geolocation } = state;
    // console.log("geolocation",geolocation);
    state.triageRequest.activeMenu = "location";

    const currentLocation =
      geolocation.longitude && geolocation.latitude
        ? { lat: geolocation.latitude, lng: geolocation.longitude }
        : this.state.currentLocation &&
          this.state.currentLocation.lat !== undefined &&
          this.state.currentLocation.lng !== undefined
          ? {
            lat: this.state.currentLocation.lat,
            lng: this.state.currentLocation.lng,
          }
          : null;
    const hasCurrentLocation =
      (!!currentLocation &&
        this.state.currentLocationParts.country !== undefined) ||
      (!!state.triageRequest.locationMeta &&
        state.triageRequest.locationMeta.country !== undefined);
    const hasCurrentLocationOrName =
      this.state.currentLocationName || hasCurrentLocation;
    const addressCantProcess = (
      <h1 className="mt-0">
        <Trans i18nKey="findcareoption.location.location_title">
          The request can't be processed, please enter a different address.
        </Trans>
      </h1>
    );
    const detectedLabel = (
      <h1 className="mt-0">
        <Trans i18nKey="findcareoption.location.detectedlocation">
          We've detected that you're in
        </Trans>
      </h1>
    );

    return (
      <div role="region" aria-label="map" className="fill-height-container flex">
        <LoadingScreen isLoading={state.isLoading}>
          <div className="fill-height-content">
            {this.state.hasError ? null : (
              <Map
                locationState={state}
                currentLocation={currentLocation}
                onCurrentLocationChange={this.onCurrentLocationChange}
                searchBoxValue={this.state.searchBoxDisplay}
                key={this.state.searchBoxDisplay}
                //center={currentLocation}
                header={
                  <div className="map-header-box-container standby-location-objects standby-location-objects-gradient-top">
                    <div className="standby-location-object standby-location-object-top">
                      <div className="standby-location-card">
                        <div className="standby-location-card-inner" autoFocus>
                          {this.state.currentLocationParts.country !== undefined
                            ? detectedLabel
                            : ""}
                          <div>
                            <span className="marginTopQuestion marginBottomQuestion">
                              {this.state.currentLocationParts.country ===
                                undefined ? (
                                addressCantProcess
                              ) : hasCurrentLocationOrName ? (
                                this.state.currentLocationName ? (
                                  this.state.currentLocationName // From map search
                                ) : (
                                  `${currentLocation.lat}, ${currentLocation.lng}`
                                )
                              ) : (
                                <b>Location Unknown</b>
                              )}
                            </span>
                            {this.state.currentLocationParts.country ===
                              undefined ? (
                              ""
                            ) : (
                              <a
                                className="standby-location-card-edit ml-2"
                                onClick={this.handleSearchBox}
                                onKeyDown={(e) => {
                                  if (e.key == " " || e.key == "Enter" || e.key == "Spacebar") {
                                    this.handleSearchBox(e);
                                    document.getElementById("google-map-searchbox").focus();
                                  }
                                }}
                                href='#'
                                role="button"
                              >
                                <Trans i18nKey="findcareoption.location.Edit">
                                  Edit
                                </Trans>
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              >
              </Map>
            )}
          </div>

          <div className="fill-height-footer">
            <div className="content-width">
              <button
                type="button"
                className={cx(
                  "button standby-button standby-button-gradient standby-button-full-width",
                  hasCurrentLocation
                    ? "standby-button-gradient-green"
                    : "standby-button-disabled"
                )}
                disabled={!hasCurrentLocation}
                onClick={this.onNext}
                tabIndex="0"
              >
                <Trans i18nKey="findcareoption.location.Next">Next</Trans>
              </button>
            </div>
          </div>
        </LoadingScreen>
      </div>
    );
  }
}
